import axios from 'axios';
import { API_BASE_URL } from 'constant';
import { Notification } from 'interfaces/Notification.interface';

export const getAllNotificationsUser = async (userId: number) => {
  const url = `${API_BASE_URL}notification?userId=${userId}`;
  return await axios.get<Notification[]>(url);
};

export const updateAllNotificationsUser = async (
  notifications: Notification[]
) => {
  const url = `${API_BASE_URL}notification`;
  return await axios.patch<Notification[]>(url, { notifications });
};
